export const CapabilitiesMockData = [
  {
    icon: "pie-chart-04.svg",
    title: "Deep Investment Insight",
    text: "Rose AI answers your hardest questions with a profound understanding of conceptual investment thinking, ensuring precise framing and meticulous analysis to navigate the pathway to potential solutions.",
  },
  {
    icon: "dataflow-02.svg",
    title: "Structured Mathematical Logic",
    text: "Harness the power of Rose AI's refined mathematical logic that deconstructs complex questions into digestible segments, methodically exploring each facet before synthesizing them into a comprehensive response.",
  },
  {
    icon: "puzzle-piece-01.svg",
    title: "Seamless Data Connectivity",
    text: "With advanced technical engineering, Rose AI effortlessly integrates with your databases, further streamlining and automating data-driven processes for optimal efficiency.",
  },
  {
    icon: "presentation-chart-01.svg",
    title: "Clear and Cohesive Narratives",
    text: "In response to intricate queries, Rose AI delivers succinct written insights complemented by crisp visualizations, transforming data into easily comprehensible narratives for your most challenging questions.",
  },
];

export const InstitutionalSolutionsMockData = [
  {
    step: "Step 1",
    period: "<1 Month",
    title: "Scoping",
    text: "We initiate our process by engaging with your stakeholders, ideally on-site, to comprehensively understand your unique challenges, requirements, and aspirations. This foundation ensures that the subsequent steps align with your organizational objectives.",
  },
  {
    step: "Step 2",
    period: "~1 Month",
    title: "Discover and Deliver Insights",
    text: "With a clear understanding in place, our focus shifts to rapidly identifying, visualizing, and disseminating answers to your most pressing business questions. Leveraging Rose AI’s powerful platform, we efficiently transform your data into actionable insights.",
  },
  {
    step: "Step 3",
    period: "1-3 Months",
    title: "Solution Design & Implementation",
    text: "Once insights are in hand, we delve into diagnosing underlying issues and crafting bespoke solutions tailored for your institution. This phase consists of a triage approach: identifying critical areas, designing strategies, and implementing solutions that drive tangible results.",
  },
  {
    step: "Step 4",
    period: "3 Months",
    title: "Comprehensive Documentation",
    text: "As we progress, transparency and clarity remain paramount. This step ensures every aspect of the data journey is meticulously documented. From cleaning data and crafting interactive dashboards to creating a comprehensive data dictionary, we ensure every stakeholder understands and trusts the data they're working with.",
  },
  {
    step: "Step 5 (Optional)",
    period: "3 Months & Onwards",
    title: "Building a Functional Data Team",
    text: "To sustain and grow the benefits achieved, we aid in nurturing or building a proficient data team for your institution, if you don’t have one already. Depending on your needs, this can encompass hiring new talent or training your existing workforce, ensuring a long-term culture of data-driven excellence.",
  },
];
